import React from "react";
import { LoginTemplate } from "../../Templates/LoginTemplate";

export const Login = () => {
  return <LoginTemplate />;
};
